import type { RouteObject } from 'react-router';

import { ContentListPage } from './ContentList';

/**
 * `/content`. One `RouteObject`, so the file is `.route.tsx` singular.
 *
 * It sits inside the console layout route, which already runs the guard chain,
 * so it adds no loader of its own. The guard decides **navigation** only:
 * `backend-content` re-checks the caller's role on every read and every
 * transition, and the origin a call arrives from is never an authorization
 * input.
 */
export const contentListRoute: RouteObject = {
  path: 'content',
  element: <ContentListPage />,
};
